/*
  Actions definiions follow FSA Standard (https://github.com/acdlite/flux-standard-action).
  The only purpose of that object is to offer a event keys dictionnary,
  so auto-completion will list all possible events.
  This way it will also flag an error when a key is undefined
  and it gets easier to check if an event remains in use
 */

export default {
  QUIZZ_CREATE: (i) => Object.assign({
    type: 'QUIZZ_CREATE',
    payload: { text: '' },
    quizzId: Number()
  },
  {
    quizzId: i
  }),
  'QUIZZ_DESTROY': {
    type: 'QUIZZ_CREATE',
    payload: { text: '' },
    index: Number()
  },
  QUIZZ_UPDATE_CURRENT_SLIDE: (i, j) => {
    return Object.assign(
      {
        type: 'QUIZZ_UPDATE_CURRENT_SLIDE',
        payload: { text: 'Updating current Quizz slide index' },
        index: Number(),
        quizzId: Number()
      },
      {
        index: i,
        quizzId: j
      }
    )
  },
  QUIZZ_SAVE_ANSWER: (i, j, k) => {
    return Object.assign(
      {
        type: 'QUIZZ_SAVE_ANSWER',
        payload: { text: 'Save answer value' },
        quizzId: Number(),
        questionIndex: Number(),
        answerValue: Number()
      },
      {
        quizzId: i,
        questionIndex: j,
        answerValue: k
      }
    )
  },
  QUIZZ_RESET_ANSWERS: (i) => {
    return Object.assign(
      {
        type: 'QUIZZ_RESET_ANSWERS',
        payload: { text: 'Reset quizz answers' },
        quizzId: Number()
      },
      {
        quizzId: i
      }
    )
  }
};



// WEBPACK FOOTER //
// ./src/actions/quizzActions.js